/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationExclusionRuleBatchResponse {
    getFixupPrototypeFunction() { return RecommendationExclusionRuleBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<RecommendationExclusionRuleBatchResponse>): RecommendationExclusionRuleBatchResponse {
        let obj = Object.assign(new RecommendationExclusionRuleBatchResponse(), model);
        RecommendationExclusionRuleBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationExclusionRuleBatchResponse>): RecommendationExclusionRuleBatchResponse {
        if (!model) return null;
        return RecommendationExclusionRuleBatchResponse.newInstance(<RecommendationExclusionRuleBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationExclusionRuleBatchResponse) {
        if (!obj) return;

        models.RecommendationExclusionRuleBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationExclusionRuleBatchResponse): boolean {
        Object.setPrototypeOf(obj, RecommendationExclusionRuleBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.RecommendationExclusionRule.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.RecommendationExclusionRule; };

}
